//// Country Dropdown Js ////
function setCookie(name, value) {
    document.cookie = `${name}=${value}`;
}
function handleChange(newValue) {
    setCookie('hair-loss_lastQuestionafter', newValue);
}
function numberChange(lastNumber) {
    setCookie('hair-loss_lastNumber', lastNumber);
}


function findMedication(json, medicationName) {
    if (json.hasOwnProperty(medicationName)) {
      return json[medicationName];
    } else {
        return "Medication not found: " + medicationName;
    }
}

// function errorPopUp() {
//     $(".custom_error_popup").toggle();
// }

function preferredStrength(location,data) {
  $(location).html("");
   const filteredData = Object.fromEntries(
    Object.entries(data).filter(([key, value]) => key && !(key === "skipStrength" && value === "false"))
  );
  $.each(filteredData, function(key, value) {
    var itemCountList = 0;
    if (key != 'url') {
      itemCountList++;
      if (itemCountList == 1) {
        var charAt = 'A'
      }else if (itemCountList == 2) {
        var charAt = 'B'
      }else if (itemCountList == 3) {
        var charAt = 'C'
      }else if (itemCountList == 4) {
        var charAt = 'D'
      }else if (itemCountList == 5) {
        var charAt = 'E'
      }else if (itemCountList == 6) {
        var charAt = 'F'
      }else if (itemCountList == 7) {
        var charAt = 'G'
      }else if (itemCountList == 8) {
        var charAt = 'H'
      }else if (itemCountList == 9) {
        var charAt = 'I'
      }else if (itemCountList == 10) {
        var charAt = 'J'
      }
      const li = $("<li></li>");
      li.html(`
        <input type="checkbox" class="yes_btn" name="option" value="${key}">
        <label for="${key}">
          <div class="opction_btn_main">
            <div class="key_btn">
              <div class="key_helper">
                <div class="key_btn_content">
                  <span class="key_helper_hint_text">Key</span><span class="key_helper_letter">${charAt}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="checkbox_choice_content">
            <div class="text_textwrapper">${key}</div>
          </div>
          <div class="check_mark">
            <span class="icon-check">
              <i class="fal fa-check"></i>
            </span>
          </div>
        </label>
      `);
      $(location).append(li);
    }
  });
  preferredStrengthClick();
}

function extractNoscriptData(htmlString) {
  // Create a temporary DOM element
  const tempDiv = document.createElement('div');
  tempDiv.innerHTML = htmlString;

  // Find the noscript element
  const noscriptElement = tempDiv.querySelector('noscript.product_urls');
  if (!noscriptElement) {
    console.error('Noscript element not found');
    return;
  }

  // Get the JSON data from the noscript element
  const noscriptContent = noscriptElement.textContent.trim();
  let jsonData;
  try {
    jsonData = JSON.parse(noscriptContent);
  } catch (error) {
    console.error('Failed to parse JSON data from noscript:', error);
    return;
  }

  // Return the parsed JSON data
  return jsonData;
}

function findMedicationDosage(json, medicationName, dosage) {
    if (json.hasOwnProperty(medicationName)) {
        if (json[medicationName].hasOwnProperty(dosage)) {
            return json[medicationName][dosage];
        } else {
            return "Dosage not found for " + medicationName;
        }
    } else {
        return "Medication not found: " + medicationName;
    }
}


function pushValueToCookieArray(key, newValue, afterQuestion, lastNumber) {
  var existingCookieValue = document.cookie.replace(new RegExp("(?:(?:^|.*;\\s*)" + key + "\\s*\\=\\s*([^;]*).*$)|^.*$"), "$1");
  var existingObject = existingCookieValue ? JSON.parse(decodeURIComponent(existingCookieValue)) : {};

  existingObject.items = existingObject.items || [];
  existingObject.items.push(newValue);

  var expirationDate = new Date();
  expirationDate.setDate(expirationDate.getDate() + 10); 

  var cookieString = key + "=" + encodeURIComponent(JSON.stringify(existingObject)) + "; expires=" + expirationDate.toUTCString() + "; path=/";
  document.cookie = cookieString;
  handleChange(afterQuestion);
  numberChange(lastNumber);
  
}
function getCookie(key) {
  var cookies = document.cookie.split(';');  
  for (var i = 0; i < cookies.length; i++) {
    var cookie = cookies[i].trim();
    if (cookie.indexOf(key + '=') === 0) {
      return decodeURIComponent(cookie.substring(key.length + 1));
    }
  }
  return null;
}
function deleteCookie(key) {
  var expirationDate = new Date(0); // Set expiration date to a past date
  var cookieString = key + "=; expires=" + expirationDate.toUTCString() + "; path=/";

  document.cookie = cookieString;
}


$('.trigger-icon-button').on('click touch', function() {
    $(".country_dropdown").addClass("select_dropdown_show");
});

$(document).on('click touch', function(event) {
    if (!$(event.target).parents().addBack().is('.trigger-icon-button')) {
        $('.country_dropdown').removeClass('select_dropdown_show');
    }
});

$('.country_dropdown').on('click touch', function(event) {
    event.stopPropagation();
});

jQuery.getJSON('https://restcountries.com/v3.1/all?fields=flags,name,idd', function(data) {
    $('.country_list').html('');
    data.forEach(function(item, value) {
        var html = '<div class="country_select_option"><div class="country_select_bg"><div class="country_select_wrapper"><span><img src="' + item.flags["svg"] + '" style="max-width: 28px;"><div class="country_text">' + item.name.common + '</div></span><div class="select_contentText"><div class="country_code">' + item.idd.root + item.idd.suffixes + '</div></div></div></div></div>';
        $('.country_list').append(html);
    });
    $('.country_select_option').click(function() {
        var getimage = $(this).find('.country_select_wrapper img').attr('src')
        $('.distribute .trigger-icon-button__StrokeIcon img').attr('src', getimage)
        $('.country_dropdown').removeClass('select_dropdown_show');
        $('.select_country_box input').attr('data-contry-code', $(this).find('.country_code').html());
        $('.form-selected-answer [data-handle=country-code]').val($(this).find('.country_code').html());
    });
});

$("#search_countries").on("keyup", function() {
    var value = $(this).val().toLowerCase();
    $(".country_list .country_select_option").filter(function() {
        $(this).toggle($(this).text().toLowerCase().indexOf(value) > -1)
    });
});

function shakeEffect($selector) {
    $selector.removeClass('shake_animation');
    setTimeout(function() {
        $selector.addClass('shake_animation');
        setTimeout(function() {
            $selector.removeClass('shake_animation');
        }, 600);
    }, 10);
}

$('.dm-data-validate').keypress(function(e) {
    if (e.which == 13) {
        $(this).parents('.form_loop').find('button').click();
    }
    var $limit = parseInt($(this).attr('maxlength'));
    if ($(this).val().length <= $limit) {} else {
        shakeEffect($(this).parents('.form_loop'));
        return false;
    }
});

$('.form_loop textarea').keypress(function(e) {
    if (e.which == 13 && !e.shiftKey) {
        $(this).parents('.form_loop').find('button').click();
        return false;
    }
});

$('.dm-data-validate').keyup(function() {
    var d = new Date();
    var $max = parseInt($(this).attr('max')) || d.getFullYear();

    if ($(this).val() > $max) {
        shakeEffect($(this).parents('.form_loop'));
        return false;
    }
});

$('.dm-question').each(function() {
    var $question = $(this).html();
    var $que = $question;
    $que = $que.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
    $(this).parents('.form_loop').attr('data-question', $que);
    var $hidden = '<input type="hidden" name="' + $question + '" data-handle="' + $que + '">';
    $('.form-selected-answer').append($hidden);
});

$('.form-selected-answer').append('<input type="hidden" name="country code" data-handle="country-code" value="+61">');
$('.form-selected-answer [data-handle="please-enter-your-medicare-card-details"]').remove();
$('.form-selected-answer [data-handle="what-is-your-ihi"]').remove();

$('.form-selected-answer [data-handle="do-you-have-a-medicare-card"]').remove(); // dm-change 20 nov ====
$('.form-selected-answer [data-handle="do-you-agree-to-use-burst-health-s-preferred-pharmacy-provider-to-ensure-the-fastest-delivery-time-of-your-prescribed-medication"]').remove(); // dm-change 20 nov ====
$('.form-selected-answer [data-handle="do-you-have-an-nhi"]').remove(); // dm-change 20 nov ====
$('.form-selected-answer [data-handle="what-is-your-nhi"]').remove(); // dm-change ====

$('.unfortunately_country_title .back_btn_content button,.unfortunately_title .back_btn_content button, .book-consiltation-doctor .back_btn_content button').click(function() {
    var Goto = $(this).attr('goto');
    var $indexGoto = $('.form_loop[data-question=' + Goto + ']').index();
    $('.form_loop').removeClass('d-none').removeClass('d-block');

    var $limit = $('.form_loop').length;
    for (i = 0; i < $limit; i++) {
        if (i == $indexGoto) {
            $('.form_loop[data-question=' + Goto + ']').addClass('d-block').animate({
                scrollTop: 0
            });
            break;
        } else {
            var j = i + 1;
            $('.form_loop:nth-child(' + j + ')').addClass('d-none');
        }
    }
});

$('.form_loop input[type=checkbox]').click(function() {
    var Name = $(this).attr('name');
    var $parent = $(this).parents('.form_loop');
    $parent.find('input[name=' + Name + ']:checked').not(this).prop('checked', false);
});

//   FIRST YES BTN
$('.first_questions_section .form_action_btn').click(function() {
    $(this).parents('.form_loop').removeClass('d-block').addClass('d-none').next().addClass('d-block');
    $('.progress_content').show();
    pushHistory(1);
    $('html, body').animate({
      scrollTop: 0
    }, 800);
    var cookieToDelete = 'hair-loss';
    deleteCookie(cookieToDelete);
    deleteCookie("hair-loss_lastQuestionafter");
    $('.form-selected-answer input[type="hidden"]').each(function(){
      $(this).val("");
    })
  $('.form-selected-answer').append('<input type="hidden" name="Which country do you live in? *" data-handle="which-country-do-you-live-in" value="AU">');
});

$('.continue_btn_content .continue_action_btn').click(function() {
  var weightLossCookieValue = getCookie('hair-loss_lastQuestionafter');
  var weightLosslatnumCookieValue = getCookie('hair-loss_lastNumber');
  
  if (weightLossCookieValue !== null) {

    $(this).parents('.form_loop').removeClass('d-block').addClass('d-none');
    
    $('.questionnaire_form_main .form_loop').each(function(){
      var selfQuestions = $(this).data('question');
      if(selfQuestions == weightLossCookieValue){
        $(this).addClass('d-block').find('.number').html(weightLosslatnumCookieValue);
      }
    });
  }
  $('.form-selected-answer').append('<input type="hidden" name="Which country do you live in? *" data-handle="which-country-do-you-live-in" value="AU">');
});


// Selectors
var que1 = "do-you-have-any-issues-with-hair-loss-receding-hair-line-balding";
var que2 = "is-the-hair-loss-mainly-at-the-front-scalp-middle-crown-or-back-sides-patchy";
var que3 = "have-you-tried-anything-for-the-hair-loss";
var que4 = "what-have-you-tried";
var que4B = "do-you-have-any-allergies";
var que5 = "what-allergies-do-you-have";
var que5B = "are-you-taking-any-regular-medications-including-over-the-counter-or-herbal-medicines-do-you-have-any-other-medical-condition-or-previous-operations-not-already-mentioned";
var que5C = "please-enter-your-gender";
var que5D = "are-you-pregnant-or-breastfeeding";
var que6 = "please-list-all-your-medications-you-take-and-any-other-medical-conditions-or-previous-operations";
var que6B = "would-you-like-to-see-treatment-options-now-without-speaking-with-a-doctor";
var que7 = "discretion-is-at-the-heart-of-what-we-do-but-for-legal-reasons-the-name-on-your-prescription-must-be-your-full-legal-name-please-provide-your-legal-name-as-per-your-official-government-id";
var que8 = "please-provide-your-date-of-birth";
var que9 = "based-on-your-medical-history-and-individual-needs-our-doctors-have-provided-personalised-treatment-please-complete-your-mobile-phone-number-to-view-recommended-treatment";
var que10 = "do-you-have-a-medicare-card";
var que11 = "which-country-do-you-live-in";


// new question add | 11 Jul start ===============
var que12 = "would-you-like-to-skip-the-questionnaire-and-speak-with-a-doctor-instead";
var que13 = "do-you-already-have-a-script";
var que14 = "please-paste-your-e-script-link-below";
var que15 = "do-you-prefer";
var que16 = "please-select-your-preferred-strength";
var que17 = "have-you-taken-15mg-before";
var que18 = "have-you-taken-30mg-before";
var que19 = "have-you-taken-40mg-before";
var que20 = "do-you-take-any-regular-medications-have-any-known-allergies-or-any-medical-issues";
var que21 = "please-list-any-regular-medications-you-take-any-known-allergies-or-any-medical-issues";
var que22 = "do-you-have-a-medication-preference";


$('.form-selected-answer input[type="hidden"]').each(function(){
  var selfHandle = $(this).attr('data-handle');
  var weightLossCookieValue = getCookie('hair-loss');
  if (weightLossCookieValue !== null) {
      $('.continue_btn_content').removeClass('hidden');
      var weightLossObject = JSON.parse(weightLossCookieValue);
      var weightLossObjectItem = weightLossObject.items;
      for (var i = 0; i < weightLossObjectItem.length; i++) {
      var currentObject = weightLossObjectItem[i];
      for (var key in currentObject) {
        if (currentObject.hasOwnProperty(key)) {
          var cookieValue = currentObject[key];
          if(key == selfHandle){
            $('.form-selected-answer [data-handle=' + key + ']').val(cookieValue);
          }else{
            if($('#callback-form input[data-handle="'+key+'"]').length == 0){
              var getName = $(".form_loop[data-question='"+ key +"' ] .dm-question").text();
              var getQuestion = getName;
              // if(key == 'please-enter-your-sex-at-birth'){
              //   getQuestion = 'Please enter your Sex At Birth';
              // }else if(key == 'please-enter-your-waist-circumference'){
              //   getQuestion = 'Please enter your Waist Circumference';
              // }
              $('.form-selected-answer').append('<input type="hidden" name="'+getQuestion+'" data-handle="'+key+'">');
              $('.form-selected-answer [data-handle=' + key + ']').val(cookieValue);
            }
          }
        }
      }
    }

     if($('.form-selected-answer [data-handle="do-you-have-a-medicare-card"]').val() == 'no' || $('.form-selected-answer [data-handle="do-you-have-a-medicare-card"]').val() == 'No'){
        if($('#callback-form input[data-handle="what-is-your-ihi"]').length == 0){ 
          $('.form-selected-answer').append('<input type="hidden" name="What is your IHI?" data-handle="what-is-your-ihi">');
        }
     }else if($('.form-selected-answer [data-handle="do-you-have-a-medicare-card"]').val() == 'yes' || $('.form-selected-answer [data-handle="do-you-have-a-medicare-card"]').val() == 'Yes'){
       if($('#callback-form input[data-handle="please-enter-your-medicare-card-details"]').length == 0){ 
          $('.form-selected-answer').append('<input type="hidden" name="Please enter your Medicare Card details" data-handle="please-enter-your-medicare-card-details">');
          var irnHtml = '<input type="hidden" name="irn_number" data-handle="do-you-have-a-medicare-card_irn">',
              cardNumberHtml = '<input type="hidden" name="medicare-card_number" data-handle="do-you-have-a-medicare-card_number">',
              monthYearHtml = '<input type="hidden" name="medicare-card_month_year" data-handle="do-you-have-a-medicare-card_month_year">';
          $('.form-selected-answer').append([irnHtml, cardNumberHtml, monthYearHtml]);
       }
     }

     if($('.form-selected-answer [data-handle="do-you-agree-to-use-burst-health-s-preferred-pharmacy-provider-to-ensure-the-fastest-delivery-time-of-your-prescribed-medication"]').val() == 'Yes' || $('.form-selected-answer [data-handle="do-you-agree-to-use-burst-health-s-preferred-pharmacy-provider-to-ensure-the-fastest-delivery-time-of-your-prescribed-medication"]').val() == 'yes'){
        if($('#callback-form input[data-handle="do-you-have-an-nhi"]').length == 0){ 
          $('.form-selected-answer').append('<input type="hidden" name="Do you have an NHI?" data-handle="do-you-have-an-nhi">');
        }
     }

     if($('.form-selected-answer [data-handle="do-you-have-an-nhi"]').val() == 'Yes' || $('.form-selected-answer [data-handle="do-you-have-an-nhi"]').val() == 'yes'){
        if($('#callback-form input[data-handle="what-is-your-nhi"]').length == 0){ 
          $('.form-selected-answer').append('<input type="hidden" name="What is your NHI?" data-handle="what-is-your-nhi">');
        }
     }
    
  }
});


var json;
function handleResponse() {
    const data = JSON.parse(this.responseText);
    const extractedData = extractNoscriptData(data['search-product-list-2']);
    json = extractedData;
    var medication = $('.form-selected-answer [data-handle=' + que15 + ']').val();
    var getData = findMedication(json, medication);
    preferredStrength($(".form_loop[data-question='please-select-your-preferred-strength'] .maintaining_option ul"),getData);
}

const request = new XMLHttpRequest();
request.addEventListener('load', handleResponse);
request.open('GET', 'https://bursthealth.com.au/pages/product-search-data?sections=search-product-list-2', true);
request.send();


//  Scountry selector
// $('.form_loop[data-question=' + que11 + '] .form_action_btn, .form_loop[data-question=' + que11 + '] input[type=checkbox]').click(function() {
//     ValidateRemove();
//     var $parent = $(this).parents('.form_loop'),
//         $this = $(this),
//         $currentNumber = parseInt($('.form_loop[data-question=' + que1 + ']').find('.number').html());
      
//     setTimeout(function() {
//         if ($parent.find('input[type=checkbox]:checked').length) {
//             var $value = $parent.find('input[type=checkbox]:checked').val();
//             var newValue = { 'which-country-do-you-live-in': $value };

//               if($value == "NZ") {
//                 // $(".form_loop[data-question=" + que9 + "] .select_country_box").find(".trigger-icon-button__StrokeIcon img").attr("src","https://flagcdn.com/nz.svg");
//                 // $(".form_loop[data-question=" + que9 + "] .select_country_box").find("input").attr("data-contry-code","+64");

//                 // $(".select_country_box .dm-data-validate").attr("maxlength", 8);

//                 // $('.form-selected-answer').append('<input type="hidden" name="Do you have an NHI?" data-handle="do-you-have-an-nhi">');
//                 // $('.form-selected-answer').append('<input type="hidden" name="Do you agree to use Burst Health`s preferred pharmacy provider to ensure the fastest delivery time of your prescribed medication?" data-handle="do-you-agree-to-use-burst-health-s-preferred-pharmacy-provider-to-ensure-the-fastest-delivery-time-of-your-prescribed-medication">');


//                 $parent.removeClass('d-block').addClass('d-none');
//                 $('.unfortunately_country_title').addClass('d-block').removeClass('d-none').find('.back_btn_content button').attr('goto', $parent.data('question'));
//               }else {
//                 $('.form-selected-answer').append('<input type="hidden" name="Do you have a Medicare card?" data-handle="do-you-have-a-medicare-card">')

                
//                 $(".ihi_question .form_submit_btn").addClass("hide_btn");
//                 $(".ihi_question .form_next_btn").removeClass("hide_btn");
//                 $parent.removeClass('d-block').addClass('d-none').next().addClass('d-block');   // dm-change 11 Jul === 
//                 $('.form-selected-answer [data-handle=' + que11 + ']').val($value);
//               }

//                 var afterlastQuestion = $parent.next().data("question");
//                 pushValueToCookieArray('hair-loss', newValue, afterlastQuestion, $currentNumber); 
                
//                 CalculateP();
//         } else {
//             $($('#error-template-input').html()).insertAfter($parent.find('textarea'));
//             shakeEffect($(this).parents('.form_loop'));
//         }
//     }, 500);
// });



if ($('.form-selected-answer [data-handle=' + que11 + ']').val() == 'AU') {
  $(".ihi_question .form_submit_btn").addClass("hide_btn");
  $(".ihi_question .form_next_btn").removeClass("hide_btn");
}else {
  $(".ihi_question .form_submit_btn").removeClass("hide_btn");
  $(".ihi_question .form_next_btn").addClass("hide_btn");
}


// new question add | 11 Jul START ===============


$('.form_loop[data-question=' + que12 + '] input[type=checkbox]').click(function() {
    ValidateRemove();
    var $this = $(this),
        Name = $this.attr('name'),
        $parent = $this.parents('.form_loop'),
        $currentNumber = parseInt($parent.find('.number').html());
      setTimeout(function() {
        if ($parent.find('input[name=' + Name + ']:checked').length) {
            $('.form-selected-answer [data-handle=' + que12 + ']').val($this.val());
          if ($this.val() == 'Yes') {
            var newValue = { 'would-you-like-to-skip-the-questionnaire-and-speak-with-a-doctor-instead': $this.val()};
            $this.parents('.form_loop').addClass('d-none').removeClass('d-block');
            $('.form_loop[data-question="discretion-is-at-the-heart-of-what-we-do-but-for-legal-reasons-the-name-on-your-prescription-must-be-your-full-legal-name-please-provide-your-legal-name-as-per-your-official-government-id"]').addClass('d-block').find('.number').html($currentNumber + 1);
            var afterlastQuestion = $('.form_loop[data-question="discretion-is-at-the-heart-of-what-we-do-but-for-legal-reasons-the-name-on-your-prescription-must-be-your-full-legal-name-please-provide-your-legal-name-as-per-your-official-government-id"]').data("question");
            pushHistory($currentNumber + 1);
            CalculateP();
          }else {
            $this.parents('.form_loop').addClass('d-none').removeClass('d-block')
            $('.form_loop[data-question="do-you-have-any-issues-with-hair-loss-receding-hair-line-balding"]').addClass('d-block').find('.number').html($currentNumber + 1);
            pushHistory($currentNumber + 1);
            CalculateP();
            var afterlastQuestion = $('.form_loop[data-question="do-you-have-any-issues-with-hair-loss-receding-hair-line-balding"]').data("question");
          }
          
            pushValueToCookieArray('hair-loss', newValue, afterlastQuestion, $currentNumber + 1);
        }
      }, 100);
});



$('.form_loop[data-question=' + que15 + '] input[type=checkbox]').click(function() {
    ValidateRemove();
    var $this = $(this),
        $parent = $this.parents('.form_loop'),
        $currentNumber = parseInt($parent.find('.number').html());
    setTimeout(function() {
        $('.form-selected-answer [data-handle=' + que15 + ']').val($this.val());
        var medication = $this.val();
        var getData = findMedication(json, medication);
        var newValue = { 'do-you-prefer': $this.val()};
      
          if (getData.skipStrength == "true") {
            $('#callback-form').submit();
            var afterlastQuestion = "";
          } else {
            preferredStrength($(".form_loop[data-question='please-select-your-preferred-strength'] .maintaining_option ul"),getData)
            $this.parents('.form_loop').addClass('d-none').removeClass('d-block').next().addClass('d-block').find('.number').html($currentNumber + 1);
            var afterlastQuestion = $this.parents('.form_loop').next().data("question");
          }
          pushHistory($currentNumber + 1);
          CalculateP();
            pushValueToCookieArray('hair-loss', newValue, afterlastQuestion, $currentNumber + 1);
    }, 100);
});


function preferredStrengthClick() {
$('.form_loop[data-question=' + que16 + '] input[type=checkbox]').click(function() {
    ValidateRemove();
    var $this = $(this),
        Name = $this.attr('name'),
        $parent = $this.parents('.form_loop'),
        $currentNumber = parseInt($parent.find('.number').html());
    setTimeout(function() {      
      if ($parent.find('input[name=' + Name + ']:checked').length) {
          $('.form-selected-answer [data-handle=' + que16 + ']').val($this.val());

        if ($this.val() == '40 Mg') {
          $('.form-selected-answer').append('<input type="hidden" name="Have you taken 40mg before?" data-handle="have-you-taken-40mg-before">');          
          var afterlastQuestion = $this.parents('.form_loop').next().data("question");
          $this.parents('.form_loop').addClass('d-none').removeClass('d-block').next().addClass('d-block').find('.number').html($currentNumber + 1);
        }else {
          $('#callback-form').submit();
        }
           var newValue = { 'please-select-your-preferred-strength': $this.val()};
              pushHistory($currentNumber + 1);
              CalculateP();
          pushValueToCookieArray('hair-loss', newValue, afterlastQuestion, $currentNumber + 1);
      }
    }, 100);
});
}
preferredStrengthClick();

$('.form_loop[data-question=' + que16 + '] .back_btn_content button').click(function() {
    ValidateRemove();
    var $this = $(this),
        $parent = $this.parents('.form_loop'),
        $currentNumber = parseInt($parent.find('.number').html());
    setTimeout(function() {      
        $this.parents('.form_loop').addClass('d-none').removeClass('d-block').prev().addClass('d-block').find('.number').html($currentNumber - 1);
        pushHistory($currentNumber - 1);
        CalculateP();
      
    }, 100);
});

$('.form_loop[data-question=' + que19 + '] input[type=checkbox]').click(function() {
    ValidateRemove();
    var $this = $(this),
        Name = $this.attr('name'),
        $parent = $this.parents('.form_loop'),
        $currentNumber = parseInt($parent.find('.number').html());
    setTimeout(function() {
      if ($parent.find('input[name=' + Name + ']:checked').length) {
         var newValue = { 'have-you-taken-40mg-before': $this.val()};
        $('.form-selected-answer [data-handle=' + que19 + ']').val($this.val());
        if ($this.val() == 'Yes') {
                $('#callback-form').submit();
                pushHistory($currentNumber + 1);
                CalculateP();
            } else {
                $this.parents('.form_loop').addClass('d-none').removeClass('d-block');
                $('.unfortunately_title_que_40').not(".unfortunately_country_title").addClass('d-block').removeClass('d-none').find('.back_btn_content button').attr('goto', $parent.data('question'));
                var afterlastQuestion;
            }
          pushValueToCookieArray('hair-loss', newValue, afterlastQuestion, $currentNumber + 1);
      }
    }, 100);
});
$('.form_loop[data-question=' + que19 + '] .back_btn_content button').click(function() {
    ValidateRemove();
    var $this = $(this),
        $parent = $this.parents('.form_loop'),
        $currentNumber = parseInt($parent.find('.number').html());
    setTimeout(function() {      
        $this.parents('.form_loop').addClass('d-none').removeClass('d-block').prev().addClass('d-block').find('.number').html($currentNumber - 1);
        pushHistory($currentNumber - 1);
        CalculateP();
      
    }, 100);
});

$('.form_loop[data-question=' + que20 + '] input[type=checkbox]').click(function() {
    ValidateRemove();
    var $this = $(this),
        Name = $this.attr('name'),
        $parent = $this.parents('.form_loop'),
        $currentNumber = parseInt($parent.find('.number').html());
      setTimeout(function() {
        if ($parent.find('input[name=' + Name + ']:checked').length) {
            $('.form-selected-answer [data-handle=' + que20 + ']').val($this.val());
           var newValue = { 'do-you-take-any-regular-medications-have-any-known-allergies-or-any-medical-issues': $this.val()};
          if ($this.val() == 'Yes') {
            $this.parents('.form_loop').addClass('d-none').removeClass('d-block').next().addClass('d-block').find('.number').html($currentNumber + 1);
            var afterlastQuestion = $this.parents('.form_loop').next().data("question");
          }else {
            $this.parents('.form_loop').addClass('d-none').removeClass('d-block')
            $('.form_loop[data-question="based-on-your-medical-history-and-individual-needs-our-doctors-have-provided-personalised-treatment-please-complete-your-mobile-phone-number-to-view-recommended-treatment"]').addClass('d-block').find('.number').html($currentNumber + 1);
            var afterlastQuestion = $('.form_loop[data-question="based-on-your-medical-history-and-individual-needs-our-doctors-have-provided-personalised-treatment-please-complete-your-mobile-phone-number-to-view-recommended-treatment"]').data("question");
          }
          
            pushHistory($currentNumber + 1);
            CalculateP();
            pushValueToCookieArray('hair-loss', newValue, afterlastQuestion, $currentNumber + 1);
        }
      }, 100);
});


$('.form_loop[data-question=' + que21 + '] button').click(function() {
      ValidateRemove();  
      var $this = $(this),
          Name = $this.attr('name'),
          $parent = $this.parents('.form_loop'),
          $currentNumber = parseInt($parent.find('.number').html()),
          $value = $parent.find('textarea').val(),
          $value = $value.trim();
      if ($value.length) {
          $('.form-selected-answer [data-handle=' + que21 + ']').val($value);
          var newValue = { 'please-list-any-regular-medications-you-take-any-known-allergies-or-any-medical-issues': $value };
          $this.parents('.form_loop').addClass('d-none').removeClass('d-block')
          $('.form_loop[data-question="based-on-your-medical-history-and-individual-needs-our-doctors-have-provided-personalised-treatment-please-complete-your-mobile-phone-number-to-view-recommended-treatment"]').addClass('d-block').find('.number').html($currentNumber + 1);
          var afterlastQuestion = $('.form_loop[data-question="based-on-your-medical-history-and-individual-needs-our-doctors-have-provided-personalised-treatment-please-complete-your-mobile-phone-number-to-view-recommended-treatment"]').data("question");
        
          pushValueToCookieArray('hair-loss', newValue, afterlastQuestion, $currentNumber + 1);  
          pushHistory($currentNumber + 1);
          CalculateP();
      } else {
          shakeEffect($parent);
          $($('#error-template-input').html()).insertAfter($parent.find('textarea'));
          setTimeout(function() {
              $('.valid_date_text').remove();
          }, 2500);
      }
  });
$('.form_loop[data-question=' + que22 + '] input[type=checkbox]').click(function() {
    ValidateRemove();
    var $this = $(this),
        Name = $this.attr('name'),
        $parent = $this.parents('.form_loop'),
        $currentNumber = parseInt($parent.find('.number').html());
      setTimeout(function() {
        if ($parent.find('input[name=' + Name + ']:checked').length) {
            $('.form-selected-answer [data-handle=' + que22 + ']').val($this.val());
          if ($this.val() == 'Yes') {
            var newValue = { 'do-you-have-a-medication-preference': $this.val()};
            $this.parents('.form_loop').addClass('d-none').removeClass('d-block').next().addClass('d-block').find('.number').html($currentNumber + 1);
            pushHistory($currentNumber + 1);
            CalculateP();
            var afterlastQuestion = $this.parents('.form_loop').next().data("question");
          }else {
            $('#callback-form').submit();
            var afterlastQuestion = "";
          }
          
            pushValueToCookieArray('hair-loss', newValue, afterlastQuestion, $currentNumber + 1);
        }
      }, 100);
});


// new question add | 11 Jul END ===============



//  STEP 1
$('.form_loop[data-question=' + que1 + '] input[type=checkbox]').click(function() {
    ValidateRemove();
    var $parent = $(this).parents('.form_loop'),
        $this = $(this),
        $currentNumber = parseInt($parent.find('.number').html()),
        $value = $parent.find('input[type=checkbox]:checked').val();
    setTimeout(function() {
        if ($parent.find('input[type=checkbox]:checked').length) {
            if ($value == 'yes' || $value == 'Yes') {
                $parent.removeClass('d-block').addClass('d-none').next().addClass('d-block').find('.number').html($currentNumber + 1);
                $('.form-selected-answer [data-handle=' + que1 + ']').val($value);
                pushHistory($currentNumber + 1);
                CalculateP();
                var newValue = { 'do-you-have-any-issues-with-hair-loss-receding-hair-line-balding': $value };
                var afterlastQuestion = $parent.next().data("question");
                pushValueToCookieArray('hair-loss', newValue, afterlastQuestion,$currentNumber + 1); 
            } else {
                CalculateP();
                $this.parents('.form_loop').addClass('d-none').removeClass('d-block');
                $('.unfortunately_title').not($('.unfortunately_title_only_back,.unfortunately_country_title')).addClass('d-block').removeClass('d-none').find('.back_btn_content button').attr('goto', $parent.data('question'));
                $('.progress_content .progress_title span').html('100');
                $('#form_progress_bar').css('width', '100%');
            }
        }
    }, 100);
});

//  STEP 2
$('.form_loop[data-question=' + que2 + '] input[type=checkbox]').click(function() {
    ValidateRemove();
    var $this = $(this),
        Name = $this.attr('name'),
        $parent = $this.parents('.form_loop'),
        $currentNumber = parseInt($parent.find('.number').html());
    setTimeout(function() {
        if ($parent.find('input[type=checkbox]:checked').length) {
            var $value = $parent.find('input[type=checkbox]:checked').val();
            $parent.removeClass('d-block').addClass('d-none').next().addClass('d-block').find('.number').html($currentNumber + 1);
            $('.form-selected-answer [data-handle=' + que2 + ']').val($value);
            pushHistory($currentNumber + 1);
            CalculateP();
            var newValue = { 'is-the-hair-loss-mainly-at-the-front-scalp-middle-crown-or-back-sides-patchy': $value };
            var afterlastQuestion = $parent.next().data("question");
            pushValueToCookieArray('hair-loss', newValue, afterlastQuestion,$currentNumber + 1); 
        }
    }, 100);
});

// STEP 3
$('.form_loop[data-question=' + que3 + '] input[type=checkbox]').click(function() {
    ValidateRemove();
    var $this = $(this),
        Name = $this.attr('name'),
        $parent = $this.parents('.form_loop'),
        $currentNumber = parseInt($parent.find('.number').html());
    setTimeout(function() {
        if ($parent.find('input[name=' + Name + ']:checked').length) {
            $('.form-selected-answer [data-handle=' + que3 + ']').val($this.val());
            var newValue = { 'have-you-tried-anything-for-the-hair-loss': $this.val() };
            if ($this.val() == 'Yes') {
                $this.parents('.form_loop').addClass('d-none').removeClass('d-block').next().addClass('d-block').find('.number').html($currentNumber + 1);
                pushHistory($currentNumber + 1);
                CalculateP();
                var afterlastQuestion = $this.parents('.form_loop').next().data("question");
            } else {
                $this.parents('.form_loop').addClass('d-none').removeClass('d-block').next().next().addClass('d-block').find('.number').html($currentNumber + 1);
                pushHistory($currentNumber + 1);
                CalculateP();
                var afterlastQuestion = $this.parents('.form_loop').next().next().data("question");
            }
            pushValueToCookieArray('hair-loss', newValue, afterlastQuestion,$currentNumber + 1); 
        }
    }, 100);
});

// STEP 4
$('.form_loop[data-question=' + que4 + '] button').click(function() {
    ValidateRemove();
    var $this = $(this),
        Name = $this.attr('name'),
        $parent = $this.parents('.form_loop'),
        $currentNumber = parseInt($parent.find('.number').html()),
        $value = $parent.find('textarea').val(),
        $value = $value.trim();
    if ($value.length) {
        $('.form-selected-answer [data-handle=' + que4 + ']').val($value);
        setTimeout(function() {
            $this.parents('.form_loop').addClass('d-none').removeClass('d-block').next().addClass('d-block').find('.number').html($currentNumber + 1);
            pushHistory($currentNumber + 1);
            CalculateP();
            var newValue = { 'what-have-you-tried': $value };
            var afterlastQuestion = $parent.next().data("question");
            pushValueToCookieArray('hair-loss', newValue, afterlastQuestion,$currentNumber + 1); 
        }, 100);
    } else {
        shakeEffect($parent);
        $($('#error-template-input').html()).insertAfter($parent.find('textarea'));
        setTimeout(function() { $('.valid_date_text').remove(); }, 2500);
    }
});


// STEP 4B
$('.form_loop[data-question=' + que4B + '] input[type=checkbox]').click(function() {
    ValidateRemove();
    var $this = $(this),
        Name = $this.attr('name'),
        $parent = $this.parents('.form_loop'),
        $currentNumber = parseInt($parent.find('.number').html());
    setTimeout(function() {
        var newValue = { 'do-you-have-any-allergies': $this.val() };
        if ($parent.find('input[name=' + Name + ']:checked').length) {
            $('.form-selected-answer [data-handle=' + que4B + ']').val($this.val());
            if ($this.val() == 'Yes') {
                $this.parents('.form_loop').addClass('d-none').removeClass('d-block').next().addClass('d-block').find('.number').html($currentNumber + 1);
                pushHistory($currentNumber + 1);
                CalculateP();
                var afterlastQuestion = $this.parents('.form_loop').next().data("question");
            } else {
                $this.parents('.form_loop').addClass('d-none').removeClass('d-block').next().next().addClass('d-block').find('.number').html($currentNumber + 1);
                pushHistory($currentNumber + 1);
                CalculateP();
                var afterlastQuestion = $this.parents('.form_loop').next().next().data("question");
            }
            pushValueToCookieArray('hair-loss', newValue, afterlastQuestion,$currentNumber + 1); 
        }
    }, 100);
});

// STEP 5
$('.form_loop[data-question=' + que5 + '] button').click(function() {
    ValidateRemove();
    var $this = $(this),
        Name = $this.attr('name'),
        $parent = $this.parents('.form_loop'),
        $currentNumber = parseInt($parent.find('.number').html()),
        $value = $parent.find('textarea').val(),
        $value = $value.trim();
    if ($value.length) {
        $('.form-selected-answer [data-handle=' + que5 + ']').val($value);
        setTimeout(function() {
            $this.parents('.form_loop').addClass('d-none').removeClass('d-block').next().addClass('d-block').find('.number').html($currentNumber + 1);
            pushHistory($currentNumber + 1);
            CalculateP();
            var newValue = { 'what-allergies-do-you-have': $value };
            var afterlastQuestion = $this.parents('.form_loop').next().data("question");
            pushValueToCookieArray('hair-loss', newValue, afterlastQuestion,$currentNumber + 1); 
        }, 100);
    } else {
        shakeEffect($parent);
        $($('#error-template-input').html()).insertAfter($parent.find('textarea'));
        setTimeout(function() { $('.valid_date_text').remove(); }, 2500);
    }
});

// STEP 5B
$('.form_loop[data-question=' + que5B + '] input[type=checkbox]').click(function() {
    ValidateRemove();
    var $this = $(this),
        Name = $this.attr('name'),
        $parent = $this.parents('.form_loop'),
        $currentNumber = parseInt($parent.find('.number').html());
    setTimeout(function() {
        if ($parent.find('input[name=' + Name + ']:checked').length) {
            $('.form-selected-answer [data-handle=' + que5B + ']').val($this.val());
            var newValue = { 'are-you-taking-any-regular-medications-including-over-the-counter-or-herbal-medicines-do-you-have-any-other-medical-condition-or-previous-operations-not-already-mentioned': $this.val() };
            if ($this.val() == 'Yes') {
                $this.parents('.form_loop').addClass('d-none').removeClass('d-block').next().addClass('d-block').find('.number').html($currentNumber + 1);
                pushHistory($currentNumber + 1);
                CalculateP();
                var afterlastQuestion = $this.parents('.form_loop').next().data("question");
            } else {
                $this.parents('.form_loop').addClass('d-none').removeClass('d-block').next().next().addClass('d-block').find('.number').html($currentNumber + 1);
                pushHistory($currentNumber + 1);
                CalculateP();
                var afterlastQuestion = $this.parents('.form_loop').next().next().data("question");
            }
            pushValueToCookieArray('hair-loss', newValue, afterlastQuestion,$currentNumber + 1); 
        }
    }, 100);
});

// STEP 5C
$('.form_loop[data-question=' + que5C + '] input[type=checkbox]').click(function() {
    ValidateRemove();
    var $this = $(this),
        Name = $this.attr('name'),
        $parent = $this.parents('.form_loop'),
        $currentNumber = parseInt($parent.find('.number').html());
    setTimeout(function() {
        if ($parent.find('input[name=' + Name + ']:checked').length) {
            $('.form-selected-answer [data-handle=' + que5C + ']').val($this.val());
            var newValue = { 'please-enter-your-gender': $this.val() };
            if($this.val() != 'Male'){
              $this.parents('.form_loop').addClass('d-none').removeClass('d-block').next().addClass('d-block').find('.number').html($currentNumber + 1);
              var afterlastQuestion = $this.parents('.form_loop').next().data("question");
            }else{
              if($('.form-selected-answer [data-handle=' + que11 + ']').val() == 'NZ'){
                $this.parents('.form_loop').addClass('d-none').removeClass('d-block').next().next().next().addClass('d-block').find('.number').html($currentNumber + 1);
                var afterlastQuestion = $this.parents('.form_loop').next().next().next().data("question");
              }else{
                $this.parents('.form_loop').addClass('d-none').removeClass('d-block').next().next().addClass('d-block').find('.number').html($currentNumber + 1);
                var afterlastQuestion = $this.parents('.form_loop').next().next().data("question");
              }
            }
            pushValueToCookieArray('hair-loss', newValue, afterlastQuestion,$currentNumber + 1); 
            pushHistory($currentNumber + 1);
            CalculateP();
        }
    }, 100);
});

// STEP 5D
$('.form_loop[data-question=' + que5D + '] input[type=checkbox]').click(function() {
    ValidateRemove();
    var $this = $(this),
        Name = $this.attr('name'),
        $parent = $this.parents('.form_loop'),
        $currentNumber = parseInt($parent.find('.number').html());
    setTimeout(function() {
        if ($parent.find('input[name=' + Name + ']:checked').length) {
            $('.form-selected-answer [data-handle=' + que5D + ']').val($this.val());
          var newValue = { 'are-you-pregnant-or-breastfeeding': $this.val() };
          if($this.val() == "Yes" || $this.val() == "yes" ){
            $this.parents('.form_loop').addClass('d-none').removeClass('d-block');
            $('.unfortunately_title').not($('.unfortunately_title_only_back,.unfortunately_country_title')).addClass('d-block').removeClass('d-none').find('.back_btn_content button').attr('goto', $parent.data('question'));
          }else{
            if($('.form-selected-answer [data-handle=' + que11 + ']').val() == 'NZ'){
              $this.parents('.form_loop').addClass('d-none').removeClass('d-block').next().next().addClass('d-block').find('.number').html($currentNumber + 1);
              var afterlastQuestion = $this.parents('.form_loop').next().next().data("question");
              pushValueToCookieArray('hair-loss', newValue, afterlastQuestion,$currentNumber + 1); 
            }else{
              $this.parents('.form_loop').addClass('d-none').removeClass('d-block').next().addClass('d-block').find('.number').html($currentNumber + 1);
              var afterlastQuestion = $this.parents('.form_loop').next().data("question");
              pushValueToCookieArray('hair-loss', newValue, afterlastQuestion,$currentNumber + 1); 
            }
            
          }
            pushHistory($currentNumber + 1);
            CalculateP();
        }
    }, 100);
});

// STEP 6
$('.form_loop[data-question=' + que6 + '] button').click(function() {
    ValidateRemove();
    var $this = $(this),
        Name = $this.attr('name'),
        $parent = $this.parents('.form_loop'),
        $currentNumber = parseInt($parent.find('.number').html()),
        $value = $parent.find('textarea').val(),
        $value = $value.trim();
    if ($value.length) {
        $('.form-selected-answer [data-handle=' + que6 + ']').val($value);
        setTimeout(function() {
            $this.parents('.form_loop').addClass('d-none').removeClass('d-block').next().addClass('d-block').find('.number').html($currentNumber + 1);
            pushHistory($currentNumber + 1);
            CalculateP();
            var newValue = { 'please-list-all-your-medications-you-take-and-any-other-medical-conditions-or-previous-operations': $value };
            var afterlastQuestion = $this.parents('.form_loop').next().data("question");
            pushValueToCookieArray('hair-loss', newValue, afterlastQuestion,$currentNumber + 1); 
        }, 100);
    } else {
        shakeEffect($parent);
        $($('#error-template-input').html()).insertAfter($parent.find('textarea'));
        setTimeout(function() { $('.valid_date_text').remove(); }, 2500);
    }
});

// STEP 6B
$('.form_loop[data-question=' + que6B + '] input[type=checkbox]').click(function() {
    ValidateRemove();
    var $this = $(this),
        Name = $this.attr('name'),
        $parent = $this.parents('.form_loop'),
        $currentNumber = parseInt($parent.find('.number').html());
    setTimeout(function() {
        if ($parent.find('input[name=' + Name + ']:checked').length) {
            $('.form-selected-answer [data-handle=' + que6B + ']').val($this.val());
            var newValue = { 'would-you-like-to-see-treatment-options-now-without-speaking-with-a-doctor': $this.val() };
            if ($this.val() == 'Yes') {
                $this.parents('.form_loop').addClass('d-none').removeClass('d-block').next().addClass('d-block').find('.number').html($currentNumber + 1);
                pushHistory($currentNumber + 1);
                CalculateP();
                var afterlastQuestion = $this.parents('.form_loop').next().data("question");
            } else {
                $this.parents('.form_loop').addClass('d-none').removeClass('d-block');
                $('.book-consiltation-doctor').addClass('d-block').removeClass('d-none').find('.back_btn_content button').attr('goto', $parent.data('question'));
                pushHistory($currentNumber + 1);
                CalculateP();
                var afterlastQuestion = $('.book-consiltation-doctor').data("question");
            }
            pushValueToCookieArray('hair-loss', newValue, afterlastQuestion ,$currentNumber + 1); 
        }
    }, 100);
});

// STEP 7
$('.form_loop[data-question=' + que7 + '] button').click(function() {
    ValidateRemove();
    var $this = $(this),
        Name = $this.attr('name'),
        $parent = $this.parents('.form_loop'),
        $currentNumber = parseInt($parent.find('.number').html()),
        $value = $parent.find('textarea').val(),
        $value = $value.trim();
    if ($value.length) {
        $('.form-selected-answer [data-handle=' + que7 + ']').val($value);
        setTimeout(function() {
            $this.parents('.form_loop').addClass('d-none').removeClass('d-block').next().addClass('d-block').find('.number').html($currentNumber + 1);
            pushHistory($currentNumber + 1);
            CalculateP();
            var newValue = { 'discretion-is-at-the-heart-of-what-we-do-but-for-legal-reasons-the-name-on-your-prescription-must-be-your-full-legal-name-please-provide-your-legal-name-as-per-your-official-government-id': $value };
            var afterlastQuestion = $this.parents('.form_loop').next().data("question");
            pushValueToCookieArray('hair-loss', newValue, afterlastQuestion ,$currentNumber + 1); 
        }, 100);
    } else {
        shakeEffect($parent);
        $($('#error-template-input').html()).insertAfter($parent.find('textarea'));
        setTimeout(function() { $('.valid_date_text').remove(); }, 2500);
    }
});

// STEP 8
$('.form_loop[data-question=' + que8 + '] .form_action_btn').click(function() {
    ValidateRemove();
    $('.dm-error').remove();
    var $MM = $('.birth_date_field .month input').val(),
        $DD = $('.birth_date_field .day input').val(),
        $YY = $('.birth_date_field .year input').val(),
        InputDate = new Date($MM + '/' + $DD + '/' + $YY),
        Today = new Date(),
        $currentNumber = parseInt($(this).parents('.form_loop').find('.number').html()),
        Difference_In_Time = Today.getTime() - InputDate.getTime(),
        Difference_In_Days = Difference_In_Time / (1000 * 3600 * 24 * 365);

    if (Difference_In_Days >= 18 && $MM != '' && $DD != '' && $YY != '') {
        pushHistory($currentNumber + 1);
        $('.form-selected-answer [data-handle=' + que8 + ']').val($DD + '/' + $MM + '/' + $YY);
        CalculateP();

        if ($('.form-selected-answer [data-handle=' + que12 + ']').val() == 'Yes') {
          $(this).parents('.form_loop').addClass('d-none').removeClass('d-block');
          $('.form_loop[data-question="do-you-take-any-regular-medications-have-any-known-allergies-or-any-medical-issues"]').addClass('d-block').find('.number').html($currentNumber + 1);
          var afterlastQuestion = $('.form_loop[data-question="do-you-take-any-regular-medications-have-any-known-allergies-or-any-medical-issues"]').data("question");
        }else {
          var afterlastQuestion = $(this).parents('.form_loop').next().data("question");
          $(this).parents('.form_loop').removeClass('d-block').addClass('d-none').next().addClass('d-block').find('.number').html($currentNumber + 1);
        }
      
        var newValue = { 'please-provide-your-date-of-birth': $DD + '/' + $MM + '/' + $YY };
        pushValueToCookieArray('hair-loss', newValue, afterlastQuestion ,$currentNumber + 1); 
    } else {
        shakeEffect($(this).parents('.form_loop'));
        $($('#error-template').html()).insertAfter($(this).parents('.form_loop').find('.birth_date_field'));
        setTimeout(function() { $('.valid_date_text').remove(); }, 2500);
    }
});

// STEP 9
$('.form_loop[data-question=' + que9 + '] button').click(function() {
    ValidateRemove();
    var $this = $(this),
        $parent = $this.parents('.form_loop'),
        $currentNumber = parseInt($parent.find('.number').html());

    var mobile_number_length = 10;
    var get_country_type = $('.form-selected-answer [data-handle=' + que11 + ']').val(); 
    if(get_country_type=='NZ'){
      mobile_number_length = 9;
    }
  
    if ($parent.find('.select_country_box input').val().length >= mobile_number_length) {
        $this.attr('disabled', 'disabled');
        var Value = $parent.find('.select_country_box input').val(),
            Ccode = $parent.find('.select_country_box input').data('contry-code');


        $('.form-selected-answer [data-handle=country-code]').val(Ccode);
        var newValue = { 'based-on-your-medical-history-and-individual-needs-our-doctors-have-provided-personalised-treatment-please-complete-your-mobile-phone-number-to-view-recommended-treatment': Ccode };
        $('#checkNumber').val(Value);

        if(get_country_type == 'NZ'){
          $('.form-selected-answer [data-handle=' + que9 + ']').val(Value);
          $('.form_loop[data-question=' + que9 + '] button').find('input').val(Value);
          $('.form_loop[data-question=' + que9 + '] button').parents('.form_loop').addClass('d-none').removeClass('d-block').next().next().next().addClass('d-block').find('.number').html($currentNumber + 1)
          var afterlastQuestion = $('.form_loop[data-question=' + que9 + '] button').parents('.form_loop').next().next().next().data("question");
          pushValueToCookieArray('hair-loss', newValue, afterlastQuestion ,$currentNumber + 1); 
        }else {
          $('#confirmation_popup').toggle();
        }
        CalculateP();
        $('.form-selected-answer [data-handle=' + que9 + ']').val(Value);
        // $this.parents('.form_loop').addClass('d-none').removeClass('d-block').next().addClass('d-block').find('.number').html($currentNumber + 1);
    } else {
        $($('#error-template-input').html()).insertAfter($parent.find('textarea'));
        setTimeout(function() { $('.valid_date_text').remove(); }, 2500);
        shakeEffect($parent);
    }
});

$('#confirmation_popup .confirm_button').click(function(){
   var checkVal = $(this).parents('#confirmation_popup').find('#checkNumber').val();
   var $currentNumber = parseInt($('.form_loop[data-question=' + que9 + ']').find('.number').html());
   if (checkVal.length > 9) {
    $('#confirmation_popup').toggle();
    $('.form-selected-answer [data-handle=' + que9 + ']').val(checkVal);
    $('.form_loop[data-question=' + que9 + '] button').find('input').val(checkVal);
    var newValue = { 'based-on-your-medical-history-and-individual-needs-our-doctors-have-provided-personalised-treatment-please-complete-your-mobile-phone-number-to-view-recommended-treatment': checkVal };
    var afterlastQuestion = $('.form_loop[data-question=' + que9 + '] button').parents('.form_loop').next().data("question");
    pushValueToCookieArray('hair-loss', newValue, afterlastQuestion, $currentNumber + 1); 
    $('.form_loop[data-question=' + que9 + '] button').parents('.form_loop').addClass('d-none').removeClass('d-block').next().addClass('d-block').find('.number').html($currentNumber + 1)
   }else {
      $($('#error-template-input').html()).insertAfter($parent.find('textarea'));
      setTimeout(function() { $('.valid_date_text').remove(); }, 2500);
      shakeEffect($parent);
   }
})

// $('.custom_error_popup .confirm_button').click(function(){
//     $('.custom_error_popup').toggle();
// })

// STEP ?
$('.form_loop[data-question="'+que10+'"] .maintaining_option input[type=checkbox]').click(function() {
    ValidateRemove();
    var $parent = $(this).parents('.form_loop'),
        $this = $(this);

    setTimeout(function() {
        if ($parent.find('input[type=checkbox]:checked').length) {
            var $currentNumber = parseInt($parent.find('.number').html()),
                $value = $parent.find('input[type=checkbox]:checked').val();

            var newValue = { 'do-you-have-a-medicare-card': $value };

            if ($value == "yes" || $value == "Yes") {
                $parent.addClass('d-none').removeClass('d-block').next().addClass('d-block').find('.number').html($currentNumber + 1);

                var irnHtml = '<input type="hidden" name="irn_number" data-handle="do-you-have-a-medicare-card_irn">',
                    cardNumberHtml = '<input type="hidden" name="medicare-card_number" data-handle="do-you-have-a-medicare-card_number">',
                    monthYearHtml = '<input type="hidden" name="medicare-card_month_year" data-handle="do-you-have-a-medicare-card_month_year">';

                $('.form-selected-answer').append('<input type="hidden" name="Please enter your Medicare Card details" data-handle="please-enter-your-medicare-card-details">');
                $('.form-selected-answer').append([irnHtml, cardNumberHtml, monthYearHtml]);

                var afterlastQuestion = $parent.next().data("question");

            } else {
               if($('.form-selected-answer [data-handle=' + que11 + ']').val() == 'NZ'){
                $('.form-selected-answer').append('<input type="hidden" name="What is your IHI?" data-handle="what-is-your-ihi">');
                $parent.addClass('d-none').removeClass('d-block').next().next().addClass('d-block').find('.number').html($currentNumber + 1);
                var afterlastQuestion = $parent.next().next().data("question");
              }else {
                $parent.addClass('d-none').removeClass('d-block');
                 $('.ans_for_no[data-question="what-is-your-ihi"]').addClass('d-block').find('.number').html($currentNumber + 1);
                var afterlastQuestion = $('.ans_for_no[data-question="what-is-your-ihi"]').data("question");
              }
            }
            pushValueToCookieArray('hair-loss', newValue, afterlastQuestion ,$currentNumber + 1); 
            $('.form-selected-answer [data-handle="do-you-have-a-medicare-card"]').val($value);
            pushHistory($currentNumber + 1);
            CalculateP();
        } else {
            $($('#error-template-input').html()).insertAfter($parent.find('textarea'));
            shakeEffect($(this).parents('.form_loop'));
        }
    }, 100);
});

// STEP ??
$('.form_loop[data-question="please-enter-your-medicare-card-details"] button').click(function() {
    ValidateRemove();
    var $this = $(this),
        $parent = $this.parents('.form_loop'),
        $currentNumber = parseInt($parent.find('.number').html());

    var $MM = $('.card_years_field .month input').val(),
        $YY = $('.card_years_field .year input').val(),
        $INR = $parent.find('.details_filed input.enter_irn_number').val(),
        $CardNumber = $parent.find('.details_filed input.enter_card_number').val();

    if ($parent.find('.details_filed input.enter_irn_number').val().length == 1 && $parent.find('.details_filed input.enter_card_number').val().length == 10 && $MM != '' && $MM <= 12 && $YY != '') {
        $parent.addClass('d-none').removeClass('d-block');
        $('.neurological_que[data-question="appoinment"]').addClass('d-block');
        $('.form-selected-answer [data-handle="do-you-have-a-medicare-card_irn"]').val($INR);
        $('.form-selected-answer [data-handle="do-you-have-a-medicare-card_number"]').val($CardNumber);
        $('.form-selected-answer [data-handle="do-you-have-a-medicare-card_month_year"]').val(`${$MM}/${$YY}`);
        CalculateP();


      if ($('.form-selected-answer [data-handle=' + que11 + ']').val() == 'AU') {
          var afterlastQuestion = $('.form_loop[data-question="do-you-have-a-medication-preference"]').data("question");
      }

      var newValue = { 'do-you-have-a-medicare-card_irn': $INR };
              pushValueToCookieArray('hair-loss', newValue, afterlastQuestion); 
  
      var newValue = { 'do-you-have-a-medicare-card_number': $CardNumber };
              pushValueToCookieArray('hair-loss', newValue, afterlastQuestion); 

      var newValue = { 'do-you-have-a-medicare-card_month_year': $MM+ "/" +$YY };
      pushValueToCookieArray('hair-loss', newValue, afterlastQuestion ,$currentNumber + 1); 
      
      if ($('.form-selected-answer [data-handle=' + que11 + ']').val() == 'AU') {
        $this.parents('.form_loop').addClass('d-none').removeClass('d-block');
        $('.form_loop[data-question="do-you-have-a-medication-preference"]').addClass('d-block').find('.number').html($currentNumber + 1);
        var afterlastQuestion = $('.form_loop[data-question="do-you-have-a-medication-preference"]').data("question");
      }else { 
        $parent.addClass('d-none').removeClass('d-block');
        var afterlastQuestion = "";
          $('#callback-form').submit();
      }
    } else {
        shakeEffect($parent);
        // errorPopUp();
        $($('#error-template-input').html()).insertAfter($parent.find('textarea'));
        setTimeout(function() { $('.valid_date_text').remove(); }, 2500);
    }
});

$('.form_loop[data-question="do-you-agree-to-use-burst-health-s-preferred-pharmacy-provider-to-ensure-the-fastest-delivery-time-of-your-prescribed-medication"] .maintaining_option input[type=checkbox]').click(function() {
    ValidateRemove();
    var $parent = $(this).parents('.form_loop'),
        $this = $(this);
    setTimeout(function() {
        if ($parent.find('input[type=checkbox]:checked').length) {
            var $currentNumber = parseInt($parent.find('.number').html()),
                $value = $parent.find('input[type=checkbox]:checked').val();
            console.log($value,"$value$value$value$value")

            var newValue = { 'do-you-agree-to-use-burst-health-s-preferred-pharmacy-provider-to-ensure-the-fastest-delivery-time-of-your-prescribed-medication': $value };
          
            if ($value == "Yes") {
                $('.form_loop[data-question="do-you-have-an-nhi"]').addClass('d-block');
              if($('.form-selected-answer [data-handle=' + que11 + ']').val() == 'NZ'){
                $parent.addClass('d-none').removeClass('d-block'); // new dm-changes
                $('.form_loop[data-question="do-you-have-an-nhi"]').find('.number').html($currentNumber + 1)
                var afterlastQuestion =  $('.form_loop[data-question="do-you-have-an-nhi"]').data("question");
              }else {
                $parent.addClass('d-none').removeClass('d-block').next().addClass('d-block').find('.number').html($currentNumber + 1);
                var afterlastQuestion = $parent.next().data("question");
              }
              pushValueToCookieArray('hair-loss', newValue, afterlastQuestion ,$currentNumber + 1); 
            } else {
                $this.parents('.form_loop').addClass('d-none').removeClass('d-block');
                $('.unfortunately_title_only_back').not(".unfortunately_country_title").addClass('d-block').removeClass('d-none').find('.back_btn_content button').attr('goto', $parent.data('question'));
            }
          
            $('.form-selected-answer [data-handle="do-you-agree-to-use-burst-health-s-preferred-pharmacy-provider-to-ensure-the-fastest-delivery-time-of-your-prescribed-medication"]').val($value);
            pushHistory($currentNumber + 1);
            CalculateP();
        } else {
            $($('#error-template-input').html()).insertAfter($parent.find('textarea'));
            shakeEffect($(this).parents('.form_loop'));
        }
    }, 100);
});

// STEP dm-changes =====
$('.form_loop[data-question="do-you-have-an-nhi"] .maintaining_option input[type=checkbox]').click(function() {
    ValidateRemove();
    var $parent = $(this).parents('.form_loop'),
        $this = $(this);
    setTimeout(function() {
        if ($parent.find('input[type=checkbox]:checked').length) {
            var $currentNumber = parseInt($parent.find('.number').html()),
                $value = $parent.find('input[type=checkbox]:checked').val();

            var newValue = { 'do-you-have-an-nhi': $value };

            if ($value == "Yes") {
                $parent.addClass('d-none').removeClass('d-block').next().addClass('d-block').find('.number').html($currentNumber + 1);
                $('.form-selected-answer').append('<input type="hidden" name="What is your NHI?" data-handle="what-is-your-nhi">');
                var afterlastQuestion = $parent.next().data("question");
                pushValueToCookieArray('hair-loss', newValue, afterlastQuestion ,$currentNumber + 1); 
            } else {
              $('#callback-form').submit();
            }
          console.log($value,"$value$value")
            $('.form-selected-answer [data-handle="do-you-have-an-nhi"]').val($value);
            pushHistory($currentNumber + 1);
            CalculateP();
        } else {
            $($('#error-template-input').html()).insertAfter($parent.find('textarea'));
            shakeEffect($(this).parents('.form_loop'));
        }
    }, 100);
});

// STEP dm-changes
$('.form_loop[data-question="what-is-your-nhi"] button').click(function() {
    ValidateRemove();
    var $this = $(this),
        Name = $this.attr('name'),
        $parent = $this.parents('.form_loop'),
        $currentNumber = parseInt($parent.find('.number').html()),
        $value = $parent.find('textarea').val(),
        $value = $value.trim();
    if ($value.length) {
        $('.form-selected-answer [data-handle="what-is-your-nhi"]').val($value);
        setTimeout(function() {
            pushHistory($currentNumber + 1);
            CalculateP();
          $('#callback-form').submit();
        }, 100);
    } else {
        shakeEffect($parent);
        $($('#error-template-input').html()).insertAfter($parent.find('textarea'));
        setTimeout(function() {
            $('.valid_date_text').remove();
        }, 2500);
    }
});







// STEP ???
$('.form_loop[data-question="what-is-your-ihi"] button').click(function() {
    ValidateRemove();
    var $this = $(this),
        $parent = $this.parents('.form_loop'),
        $currentNumber = parseInt($parent.find('.number').html()),
        $value = $parent.find('.details_filed input').val();
    if ($value != '') {
        CalculateP();

        if ($('.form-selected-answer [data-handle=' + que11 + ']').val() == 'AU') {
          var afterlastQuestion = $('.form_loop[data-question="do-you-have-a-medication-preference"]').data("question");
        }
        var newValue = { 'what-is-your-ihi': $value };
        pushValueToCookieArray('hair-loss', newValue, afterlastQuestion ,$currentNumber + 1); 
      
        $parent.addClass('d-none').removeClass('d-block');
        $('.form-selected-answer [data-handle="what-is-your-ihi"]').val($value);
      
      if ($('.form-selected-answer [data-handle=' + que11 + ']').val() == 'AU') {
        $this.parents('.form_loop').addClass('d-none').removeClass('d-block');
        $('.form_loop[data-question="do-you-have-a-medication-preference"]').addClass('d-block').find('.number').html($currentNumber + 1);
      }else { 
        $parent.addClass('d-none').removeClass('d-block');
        $('.neurological_que[data-question="appoinment"]').addClass('d-block').find('.number').html($currentNumber + 1);
        var afterlastQuestion = "";
        $('#callback-form').submit();
      }
    } else {
        shakeEffect($parent);
        $($('#error-template-input').html()).insertAfter($parent.find('textarea'));
        setTimeout(function() { $('.valid_date_text').remove(); }, 2500);
    }
});


// Submit Form
var $Form = $('#callback-form');
$Form.submit(function(e) {
    e.preventDefault();
    $('.loading-wrapper').show();
    ga('send', 'event', { eventCategory: 'hair-loss', eventAction: 'Submit', eventLabel: 'Hair loss form', eventValue: 1 });
    console.log("e",e)

    $Form.find("input[type='hidden']").each(function() {
      var get_data_handle = $(this).attr('data-handle');
      if(get_data_handle=='please-enter-your-medicare-card-details'){
          if($('.form-selected-answer [data-handle="do-you-have-a-medicare-card"]').val() == 'no'){
            if($(this).val() == ""){
              $(this).remove();
            }    
          }
      }else{
        if($(this).val() == ""){
          $(this).remove();
        }
      }
    })
  

    var country_selected = $('.form-selected-answer [data-handle=' + que11 + ']').val();
    if(country_selected=='NZ'){
       location.href = 'https://bursthealth.com.au/products/minoxidil-1mg-compounded-capsules-x30-nz-prices-in-aud';
    }else{
     if ($('.form-selected-answer [data-handle=' + que22 + ']').val() == 'No') {
        var redirectionMainUrl = "https://bursthealth.com.au/products/hair-loss-treatment-plan-m";
      }else{
        var medicationO = $('.form-selected-answer [data-handle=' + que15 + ']').val();
        var getDataO = findMedication(json, medicationO);
        
       if (medicationO == 'Capsules') {
        var redirectionMainUrl = 'https://bursthealth.com.au/products/hair-loss-treatment-plan-m';         
       }else if (medicationO == 'Lotion') {
        var redirectionMainUrl = "https://bursthealth.com.au/products/hair-loss-treatment-plan-c";         
       }else if (medicationO == 'Tablets') {
        var redirectionMainUrl = "https://bursthealth.com.au/products/hair-loss-treatment-plan-f";         
       }
          // var redirectionMainUrl = getDataO.skipDirectUrl;
          
        // if (getDataO.skipStrength == "true") {
        // }else {
        
        //   const medication = $('.form-selected-answer [data-handle=' + que15 + ']').val();
        //   const dosage = $('.form-selected-answer [data-handle=' + que16 + ']').val();
        //   var getData = findMedicationDosage(json, medication, dosage);
        //   // localStorage.setItem('weightloss_form', true);
        //   var redirectionMainUrl = getData.url;
        // }
      }
    }

    var noscriptContent = $('#productString_url').html();
    var urlRegex = /(https?:\/\/[^\s]+)/g;
    var urls = noscriptContent.match(urlRegex);

    
    $('.form-selected-answer').append(`<input type="hidden" name="Product redirection Url" value="${redirectionMainUrl}">`);
    $('.form-selected-answer').append(`<input type="hidden" name="Product Session id" value="${unique_id}">`);
    $.each(urls, function(index, url) {
     if (url.includes(redirectionMainUrl) || redirectionMainUrl.includes(url)) {
      $('.form-selected-answer').append(`<input type="hidden" name="Product String Url" value="true">`);
     }
    });
  
    $.ajax({
      url: $Form.attr('action'),
      cache: false,
      type: 'post',
      data: $Form.serialize(),
      success: function(itemData) {
        var data = JSON.parse(itemData);            
        var cookieToDelete = 'hair-loss';
        deleteCookie(cookieToDelete);
        deleteCookie("hair-loss_lastQuestionafter");
        location.href = data.product_link;
        
       // location.href = 'https://bursthealth.com.au/products/minoxidil-1mg-capsules-x30';
      },
      error: function() {
        console.log("ERROR");
          // location.href = 'https://bursthealth.com.au/products/minoxidil-1mg-capsules-x30';
      }
    });
});

// Functions
function CalculateP() {
    var Length = $('.form-selected-answer input').length + 1,
        AnswerLength = 0,
        Percentage = 0;
    for (i = 1; i < Length; i++) {
        if ($('.form-selected-answer input:nth-child(' + i + ')').val() != '') {
            AnswerLength = parseInt(AnswerLength) + 1;
        }
    }
    Percentage = parseInt(AnswerLength / $('.form-selected-answer input').length * 100);
    $('.progress_content .progress_title span').html(Percentage);
    $('#form_progress_bar').css('width', Percentage + '%');
}

function fillvalue(question) {
    if ($('.form-selected-answer [data-handle=' + question + ']').val() == '') {
        $('.form-selected-answer [data-handle=' + question + ']').val('No response');
    }
}

function pushHistory(number) {
    window.history.pushState("", "", location.pathname + "?question=" + number);
    ga('send', {
        hitType: 'pageview',
        page: location.pathname + location.search
    });
}

function ValidateRemove() {
    $('.form_loop .valid_date_text').remove();
}

function validateEmail($email) {
    var emailReg = /^([\w-\.]+@([\w-]+\.)+[\w-]{2,4})?$/;
    return emailReg.test($email);
}

function onmaxlength(e) {
    // var $this = $(e);
    // var maxlength = $this.attr('maxlength');
    // var value = $(e).val();
    // if (value && value.length >= maxlength) {
    //   return false;
    // }else{
    //   return true;
    // }
}